//This file is used to store js helper functions that can be used across the site
window.Helpers = {
  'renderButtonLink': function (href = '#', label = 'Read More', extraClasses = '', target = '_self') {
    return `
    <a href="${href}" target="${target}" class="mo-button ${extraClasses}">
            ${label}
            <svg class="arrow" viewBox="0 0 18 18" width="18px" height="18px" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1921_245)"><path d="m9.186.035 8.463 8.718-8.488 8.745-1.931-2.016 5.158-5.315H.445V7.34h11.943L7.255 2.024 9.186.035Z" fill="currentColor"/></g>
            </svg>
        </a>
    `;
  }
}
